module.exports = __webpack_public_path__ + "img/profile-cover.e7bff976.webp";